'use client';

import { useState, useEffect } from 'react';
import { Cookie } from 'lucide-react';
import { hasUserConsented } from '@/lib/consent';

export default function ConsentSettings() {
  const [hasConsent, setHasConsent] = useState(false);

  useEffect(() => {
    setHasConsent(hasUserConsented());
    
    const handleConsentUpdate = () => {
      setHasConsent(hasUserConsented());
    };

    window.addEventListener('consentUpdate' as any, handleConsentUpdate);
    return () => {
      window.removeEventListener('consentUpdate' as any, handleConsentUpdate);
    };
  }, []);

  const handleClick = () => {
    document.cookie = 'tobg-consent=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    window.location.reload();
  };

  if (!hasConsent) {
    return null;
  }

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-4 left-4 z-40 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-full p-3 shadow-lg hover:shadow-xl transition-shadow"
      aria-label="Cookie Settings"
      title="Cookie Settings"
    >
      <Cookie className="w-5 h-5 text-gray-600 dark:text-gray-400" />
    </button>
  );
}